import List from "@mui/material/List";
import { Box, Typography } from "@mui/material";
import { TEXT_SECONDARY } from "../colors";
import { SearchResultItem } from "./SearchResultItem";
import { SearchResult } from "../../types/SearchResult";

export const SearchResultList = (props: { data: SearchResult[] }) => {
  if (props.data.length === 0) {
    return (
      <Box style={{ padding: 20 }}>
        <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
          No results found.
        </Typography>
      </Box>
    );
  }

  return (
    <List style={styles.container}>
      {props.data.map((value) => (
        <SearchResultItem data={value} key={value.links.self} />
      ))}
    </List>
  );
};

const styles = {
  container: {
    flexDirection: "column" as const,
    display: "flex",
    padding: "10px",
  },
};
